<template>
  <div class="modal-parent">
    <div
      v-shortkey="['esc']"
      class="modal-component"
      @shortkey="emitCancel"
    >
      <div class="modal-component-topbar">
        <div class="modal-component-topbar__title">
          <slot name="title">
            {{ title }}
          </slot>
        </div>
        <div class="modal-component-topbar-actions">
          <slot name="actions">
            <template v-if="loading">
              <loader :size="25" />
            </template>
            <span
              id="exit-modal-component"
              class="modal-component-topbar__exit"
              @click="emitCancel"
              v-html="closeIcon"
            />
          </slot>
        </div>
      </div>
      <slot name="description">
        <div class="modal-component__description">
          {{ description }}
        </div>
      </slot>
      <div class="modal-component-content">
        <slot />
      </div>
      <slot name="footer">
        <div class="modal-component-footer">
          <button
            id="cancel-modal-component"
            class="btn btn--grey mr-1"
            @click="emitCancel"
          >
            {{ secondaryButtonText }}
          </button>
          <button
            id="accept-modal-component"
            class="btn"
            :disabled="loading"
            @click="emitConfirm"
          >
            {{ primaryButtonText }}
          </button>
        </div>
      </slot>
    </div>
    <div class="modal-overlay" />
  </div>
</template>

<script>
import feather from 'feather-icons'
import Loader from '@/components/loader'

export default {
  name: 'ModalComponent',
  components: {Loader},
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Generic Modal Title',
    },
    description: {
      type: String,
      default: 'Generic Modal Description',
    },
    primaryButtonText: {
      type: String,
      default: 'Submit',
    },
    secondaryButtonText: {
      type: String,
      default: 'Cancel',
    },
  },
  data() {
    return {
      closeIcon: feather.icons.x.toSvg(),
    }
  },
  methods: {
    emitCancel() {
      this.$emit('cancel')
    },
    emitConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<style lang="scss" scoped>
$modal-width-medium: 60vw;
$modal-width-large: 35vw;

.modal-component {
  @include flex-display();
  @include flex-direction(column);
  color: $dark-grey;
  position: fixed;
  width: $modal-width-medium;
  height: auto;
  min-height: 400px;
  max-height: 85vh;
  top: 3em;
  left: 50%;
  padding: 2em;
  background: $white;
  border-radius: 5px;
  border: 1px solid $light-grey;
  box-shadow: 0 30px 60px 0 rgba(56, 56, 56, 0.25);
  box-sizing: border-box;
  z-index: 1020;
  overflow: auto;
  transform: translate(-50%, 0);
  @media #{$large-display} {
    width: $modal-width-large;
  }
  @media #{$mobile} {
    max-height: 100%;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    margin-top: 0;
    box-sizing: border-box;
    transform: none;
  }
  &-topbar {
    @include flex-display();
    @include flex-justify-content(space-between);
    @include flex-align-items(flex-start);
    @media #{$mobile} {
      @include flex-align-items(center);
      margin-bottom: 1em;
    }
    &-actions {
      @include flex-display();
      @include flex-justify-content(flex-end);
      @include flex-align-items(center);
    }
    &__title {
      font-size: $large-font;
      font-weight: 600;
      color: $black;
    }
    &__exit {
      @include flex-display();
      @include flex-align-items(center);
      @include flex-justify-content(center);
      cursor: pointer;
      width: 35px;
      height: 35px;
      border-radius: 100%;
      &:hover {
        background: $off-white;
      }
    }
  }
  &__description {
    color: $grey-text;
    font-size: $small-font;
  }
  &-content {
    flex-grow: 1;
    margin-top: 1em;
  }
  &-footer {
    @include flex-display();
    @include flex-justify-content(flex-end);
    @include flex-align-items(flex-end);
    width: 100%;
    margin-top: 2em;
    flex-grow: 1;
    @media #{$mobile} {
      @include flex-justify-content(space-between);
    }
  }
}
</style>
